<!-- Content Area -->
<div class="p-4 md:p-8">
    <div class="flex justify-between items-center mb-6 gap-4">
        <h1 class="text-xl lg:text-3xl font-bold text-gray-900">Permission List</h1>
        <button (click)="openAddModal()"
            class="bg-blue-500 hover:bg-blue-600 text-white py-2 px-4 text-base lg:text-sm font-semibold rounded-lg transition flex items-center gap-2">
            <span>+</span>
            <span>Add Permission</span>
        </button>
    </div>

    <!-- Table -->
    <div class="bg-white rounded-lg shadow-sm mb-6">
        <!-- Loading State -->
        <div *ngIf="isLoading" class="py-8 text-center">
            <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            <p class="mt-2 text-gray-500">Loading...</p>
        </div>

        <!-- Table Content -->
        <div *ngIf="!isLoading" class="overflow-x-auto">
            <table class="w-full min-w-[600px]">
                <thead>
                    <tr class="border-b border-gray-200">
                        <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                            No
                        </th>
                        <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                            Name
                        </th>
                        <th class="text-center py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-100">
                    <tr *ngFor="let permission of Permission; let i = index" class="hover:bg-gray-50 transition-colors">
                        <td class="py-4 px-6 text-sm text-gray-900">
                            {{ startIndex + i }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-900">
                            {{ permission.name }}
                        </td>
                        <td class="py-4 px-6">
                            <div class="flex items-center justify-center gap-0">
                                <button (click)="openEditModal(permission.id)"
                                    class="text-gray-600 hover:text-gray-900 transition-colors border border-[#D5D5D5] py-2 px-4 rounded-l-lg hover:bg-gray-50">
                                    <img src="assets/visidea/icon/pencil-write.png" class="w-[16px] h-[16px]"
                                        alt="Edit" />
                                </button>
                                <button (click)="
                                        deletePermission(
                                            permission.id,
                                            permission.name
                                        )
                                    "
                                    class="text-red-500 hover:text-red-700 transition-colors border border-[#D5D5D5] py-2 px-4 rounded-r-lg hover:bg-red-50">
                                    <img src="assets/visidea/icon/bin.png" class="w-[16px] h-[16px]"
                                        alt="Delete" />
                                </button>
                            </div>
                        </td>
                    </tr>

                    <!-- Empty State -->
                    <tr *ngIf="Permission.length === 0">
                        <td colspan="3" class="py-8 text-center text-gray-500">
                            Tidak ada data permission
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <!-- Pagination -->
        <div *ngIf="!isLoading && Permission.length > 0"
            class="flex flex-col items-center justify-between px-6 py-4 border-t border-gray-200 gap-4">

            <!-- Info Text (Centered Top) -->
            <div class="text-center w-full order-1">
                <span class="text-sm text-gray-600">
                    Showing {{ startIndex }} to {{ endIndex }} of {{ pagination.total }} entries
                </span>
            </div>

            <!-- Pagination Controls (Center) -->
            <div class="flex items-center gap-1 order-2 md:order-2 w-full md:w-auto justify-center">
                <!-- Previous Arrow -->
                <button (click)="previousPage()" [disabled]="!canGoPrevious"
                    class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-50 disabled:hover:bg-transparent transition-colors">
                    <img src="assets/visidea/icon/left.png" class="w-[10px] h-[10px]" alt="Previous" />
                </button>

                <!-- Page Numbers -->
                <ng-container *ngFor="let page of visiblePages">
                    <button *ngIf="page !== '...'" (click)="goToPage(page)"
                        class="w-8 h-8 flex items-center justify-center rounded-lg text-sm font-medium transition-colors"
                        [ngClass]="{
                            'bg-blue-500 text-white': page === pagination.current_page,
                            'text-gray-600 hover:bg-gray-100': page !== pagination.current_page
                        }">
                        {{ page }}
                    </button>
                    <span *ngIf="page === '...'" class="w-8 h-8 flex items-center justify-center text-gray-400">
                        ...
                    </span>
                </ng-container>

                <!-- Next Arrow -->
                <button (click)="nextPage()" [disabled]="!canGoNext"
                    class="w-8 h-8 flex items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 disabled:opacity-50 disabled:hover:bg-transparent transition-colors">
                    <img src="assets/visidea/icon/right.png" class="w-[10px] h-[10px]" alt="Next" />
                </button>
            </div>

            <!-- Empty div for layout balance on desktop (Right side) -->
            <div class="hidden md:block w-[200px] order-3"></div>
        </div>
    </div>
</div>

<!-- Modal Add/Edit Permission -->
<div *ngIf="isModalOpen" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div class="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn" (click)="$event.stopPropagation()">
        <div class="flex justify-between items-center mb-6">
            <h2 class="text-2xl font-bold text-gray-900">
                {{ isEditMode ? "Edit Permission" : "Add New Permission" }}
            </h2>
            <button (click)="closeModal()" class="text-gray-400 hover:text-gray-600 text-2xl">
                &times;
            </button>
        </div>

        <form (ngSubmit)="onSubmit()" #roleFormElement="ngForm">
            <!-- Name -->
            <div class="mb-6">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Permission Name <span class="text-red-500">*</span>
                </label>
                <input type="text" [(ngModel)]="permissionForm.name" name="name" required minlength="3" maxlength="50"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter permission name (e.g., Administrator)" />
                <p class="mt-1 text-xs text-gray-500">
                    Minimal 3 karakter, maksimal 50 karakter
                </p>
            </div>

            <!-- Buttons -->
            <div class="flex gap-3">
                <button type="button" (click)="closeModal()" [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition disabled:opacity-50">
                    Cancel
                </button>
                <button type="submit" [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed">
                    <span *ngIf="!isSubmitting">
                        {{ isEditMode ? "Update" : "Create" }}
                    </span>
                    <span *ngIf="isSubmitting"> Processing... </span>
                </button>
            </div>
        </form>
    </div>
</div>
